/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const SAVESITESETINGS= createAsyncThunk(
  "saveSiteSettings/saveSiteSettings",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const saveSiteSettingsSlice = createSlice({
  name: "saveSiteSettingsSlice",
  initialState: {
    saveSiteSettings: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsaveSiteSettings: (state) => {
        state.saveSiteSettings.loading = false
        state.saveSiteSettings.error = false
        state.saveSiteSettings.data = []
        state.saveSiteSettings.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SAVESITESETINGS.fulfilled, (state, action) => {
      state.saveSiteSettings = {
        ...state.saveSiteSettings,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SAVESITESETINGS.pending, (state, action) => {
      state.saveSiteSettings = {
        ...state.saveSiteSettings,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SAVESITESETINGS.rejected, (state, action) => {
      state.saveSiteSettings = {
        ...state.saveSiteSettings,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const saveSiteSettingsAction = {
    SAVESITESETINGS,
};

export { saveSiteSettingsAction };
export default saveSiteSettingsSlice.reducer;
export const {setInitialStateOfsaveSiteSettings} = saveSiteSettingsSlice.actions